import {Component, HostBinding, Input} from '@angular/core';
import {JackingFormInstanceEditor, JackingSectionGroupTemplateEditor} from '../../../../../models/jacking-v2/jacking.models';

@Component({
  selector: 'jacking-load-cells-grid',
  templateUrl: 'jacking-load-cells-grid.component.html',
})
export class JackingLoadCellsGridComponent {
  @Input() editor: JackingFormInstanceEditor;
  @Input() group: JackingSectionGroupTemplateEditor;
  @Input() legsCount: number;
  @Input() isReadonly = false;

  // Fixed for now, but easy to change later
  readonly columns = ['B', 'A', 'C'];

  get legNumbersInDisplayOrder(): number[] {
    const layouts = this.editor?.template?.legLayouts ?? [];
    return layouts.length
      ? layouts.slice().sort((a, b) => a.displayOrder - b.displayOrder).map(x => x.legNumber)
      : Array.from({ length: this.legsCount || 4 }, (_, i) => i + 1);
  }

  // 4 rows x 6 columns = 24 cells,
  // Column order inside each chord group is B A C, and each has 2 cols (B1,B2, A1,A2, C1,C2)
  get cellMatrix(): number[][] {
    return [
      [1, 2, 9, 10, 17, 18],
      [3, 4, 11, 12, 19, 20],
      [5, 6, 13, 14, 21, 22],
      [7, 8, 15, 16, 23, 24],
    ];
  }

  isSelected(legNumber: number, cellNumber: number): boolean {
    const leg = this.getOrCreateLeg(legNumber, false);
    return !!leg && leg.selectedCells.indexOf(cellNumber) >= 0;
  }

  toggle(legNumber: number, cellNumber: number) {
    if (this.isReadonly) { return; }

    this.ensureLoadCellsRoot();

    const leg = this.getOrCreateLeg(legNumber, true);
    const idx = leg.selectedCells.indexOf(cellNumber);

    if (idx >= 0) {
      leg.selectedCells.splice(idx, 1);
    } else {
      leg.selectedCells.push(cellNumber);
      leg.selectedCells.sort((a, b) => a - b);
    }
  }

  private ensureLoadCellsRoot() {
    if (!this.editor.loadCells) {
      this.editor.loadCells = {
        sectionGroupTemplateId: this.group.id,
        legs: [],
      };
    }

    // keep group id in sync
    this.editor.loadCells.sectionGroupTemplateId = this.group.id;
  }

  private getOrCreateLeg(legNumber: number, create: boolean) {
    const root = this.editor.loadCells;
    if (!root) { return null; }

    let leg = root.legs.find(l => l.legNumber === legNumber);
    if (!leg && create) {
      leg = { legNumber, selectedCells: [] };
      root.legs.push(leg);
    }
    return leg;
  }
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/components/jacking-load-cells-grid/jacking-load-cells-grid.component.ts